/**
 * Auto-Identity service catalog.
 * Maps issuer names to deterministic HSL colors so visual identity is
 * stable across devices without ever shipping logos (which would be IP).
 *
 * Lookup: case-insensitive substring match against issuer.
 * Fallback: 12-hue palette indexed by FNV-1a hash of the issuer.
 */

export interface ServiceColor {
  hue: number;
  sat: number;
  lit: number;
}

export const KNOWN_SERVICES: Record<string, ServiceColor> = {
  github: { hue: 0, sat: 0, lit: 95 },
  google: { hue: 217, sat: 89, lit: 61 },
  gmail: { hue: 4, sat: 90, lit: 58 },
  amazon: { hue: 35, sat: 100, lit: 50 },
  aws: { hue: 35, sat: 100, lit: 50 },
  cloudflare: { hue: 22, sat: 100, lit: 56 },
  microsoft: { hue: 207, sat: 90, lit: 54 },
  apple: { hue: 0, sat: 0, lit: 90 },
  proton: { hue: 270, sat: 70, lit: 64 },
  protonmail: { hue: 270, sat: 70, lit: 64 },
  twitter: { hue: 203, sat: 89, lit: 53 },
  x: { hue: 0, sat: 0, lit: 95 },
  facebook: { hue: 220, sat: 67, lit: 50 },
  meta: { hue: 220, sat: 67, lit: 50 },
  instagram: { hue: 320, sat: 80, lit: 60 },
  discord: { hue: 235, sat: 86, lit: 65 },
  slack: { hue: 327, sat: 87, lit: 56 },
  dropbox: { hue: 213, sat: 100, lit: 50 },
  notion: { hue: 0, sat: 0, lit: 90 },
  linear: { hue: 248, sat: 60, lit: 60 },
  figma: { hue: 280, sat: 80, lit: 65 },
  vercel: { hue: 0, sat: 0, lit: 95 },
  netlify: { hue: 175, sat: 75, lit: 50 },
  stripe: { hue: 250, sat: 70, lit: 65 },
  paypal: { hue: 215, sat: 80, lit: 45 },
  bitcoin: { hue: 33, sat: 95, lit: 55 },
  coinbase: { hue: 222, sat: 88, lit: 56 },
  binance: { hue: 48, sat: 95, lit: 55 },
  twitch: { hue: 264, sat: 100, lit: 65 },
  reddit: { hue: 16, sat: 100, lit: 56 }
};

/** Fallback hues for unknown services — 12 evenly-distinct hues. */
export const FALLBACK_HUES = [200, 30, 270, 340, 145, 240, 0, 50, 160, 195, 290, 90];
